import React, { useEffect } from "react";
// import Home from "./components/pages/Home";
// import Header from "./Header";

function App() {

  useEffect(() => {
    window.location.href = "https://zkcodex.com";
  }, []);

  return (
    <div className=" text-white relative flex gap-20  flex-col  min-h-screen w-full  p-4  md:p-8">
      {/* <Header />
      <Home /> */}
    </div>
  );
}

export default App;
